module.exports = __webpack_public_path__ + "img/8e784a0511108274aecfc6711bac6b34.png";